/**
 * @Time    : 2024/1/12 15:42
 * @Author  : tlovet
 * @Software: WebStorm
 */

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: AUTH.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  return {
    isAdmin: (currentUser && currentUser?.currentAuthority?.includes('admin')) || false,
    isSre: (currentUser && currentUser?.currentAuthority?.includes('sre')) || false,
    isSreAndAdmin:
      (currentUser &&
        currentUser?.currentAuthority?.includes('sre') &&
        currentUser?.currentAuthority?.includes('admin')) ||
      false,
    isSreOrAdmin:
      (currentUser && currentUser?.currentAuthority?.includes('sre')) ||
      currentUser?.currentAuthority?.includes('admin') ||
      false,
  };
}
